import { useEffect, useState } from "react";
import { Download, Loader2, FileType2, PencilLine } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { aiApi, absUrl } from "./aiApi";
import AIWordEditor from "./AIWordEditor";

export default function AIWordPreview({ file, onClose }) {
  const [cur, setCur] = useState(null);
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");
  const [editing, setEditing] = useState(false);
  const [rev, setRev] = useState(0);
  useEffect(() => { setCur(file); setEditing(false); }, [file]);
  useEffect(() => {
    if (!cur) return;
    setDoc(null); setErr("");
    aiApi.wordHtml(cur.url).then(setDoc).catch((e) => setErr(e.response?.data?.detail || "Dokumen tidak dapat dibuka"));
  }, [cur, rev]);
  const dl = cur && `${absUrl(cur.url.replace(/&download=1/, ""))}&download=1`;
  const onSaved = (r) => { setCur({ url: r.url, filename: r.filename }); setRev((v) => v + 1); };
  return (
    <Dialog open={!!file} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="z-[10004] sm:max-w-3xl w-[95vw] h-[88vh] rounded-3xl flex flex-col p-3" data-testid="ai-word-preview-dialog"
        onInteractOutside={(e) => editing && e.preventDefault()}>
        <DialogHeader><DialogTitle className="text-sm truncate pr-6 flex items-center gap-2"><FileType2 className="h-4 w-4 text-sky-600" />{doc?.filename || cur?.filename}{editing && <span className="text-[10px] font-bold text-sky-600 bg-sky-50 rounded-full px-2 py-0.5">Mod Edit</span>}</DialogTitle></DialogHeader>
        {editing ? <AIWordEditor key={`${cur?.url}-${rev}`} file={cur} onSaved={onSaved} onCancel={() => setEditing(false)} /> : (
          <>
            <div className="flex-1 overflow-y-auto rounded-2xl border border-slate-100 bg-slate-50 p-3">
              {err ? <div className="text-sm text-rose-600 p-4" data-testid="ai-word-preview-error">{err}</div>
                : !doc ? <div className="h-full grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>
                  : <div className="ai-word-page mx-auto max-w-[680px] bg-white shadow-sm rounded-lg px-6 py-7 text-[13px] leading-relaxed text-slate-800" data-testid="ai-word-preview-body" dangerouslySetInnerHTML={{ __html: doc.html }} />}
            </div>
            <div className="self-end flex items-center gap-2">
              {!err && <button type="button" onClick={() => setEditing(true)} disabled={!doc} data-testid="ai-word-preview-edit-btn"
                className="h-9 px-4 rounded-full border border-sky-200 bg-white text-sky-700 text-xs font-bold inline-flex items-center gap-1.5 hover:bg-sky-50 transition-colors disabled:opacity-50"><PencilLine className="h-3.5 w-3.5" />Edit Sendiri</button>}
              <a href={dl} className="h-9 px-4 rounded-full bg-gradient-to-r from-pink-500 to-amber-400 text-white text-xs font-bold inline-flex items-center gap-1.5" data-testid="ai-word-preview-download"><Download className="h-3.5 w-3.5" />Muat Turun</a>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
